import { datetimeToSec, datetimeToMonth } from '@/common/js/filters'
import { platformData } from './platformData.js'

/**
 * @description: 游戏回款表格选项参数
 */
export const gamePaybackOptions = {
  border: true,
  showHeaderOverflow: true,
  showOverflow: 'tooltip',
  columnConfig: {
    resizable: true
  },
  data: [],
  height: 500,
  columns: [
    {
      title: '天数',
      field: 'seriesNo'
    },
    {
      title: '中间件游戏',
      field: 'mgameName'
    },
    {
      title: '平台',
      field: 'platform',
      formatter: ({ cellValue }) => (cellValue ? platformData.filter((p) => p.id === cellValue).pop().name : '未知')
    },
    {
      title: '合格标准（自然日）',
      field: 'naturePassStd',
      width: 140,
      formatter: ({ cellValue }) => (cellValue ? cellValue + '%' : '-')
    },
    {
      title: '优秀标准（自然日）',
      field: 'natureExcellentStd',
      width: 140,
      formatter: ({ cellValue }) => (cellValue ? cellValue + '%' : '-')
    },
    {
      title: '卓越标准（自然日）',
      field: 'natureOutstandingStd',
      width: 140,
      formatter: ({ cellValue }) => (cellValue ? cellValue + '%' : '-')
    },
    {
      title: '合格标准（周期日）',
      field: 'periodPassStd',
      width: 140,
      formatter: ({ cellValue }) => (cellValue ? cellValue + '%' : '-')
    },
    {
      title: '优秀标准（周期日）',
      field: 'periodExcellentStd',
      width: 140,
      formatter: ({ cellValue }) => (cellValue ? cellValue + '%' : '-')
    },
    {
      title: '卓越标准（周期日）',
      field: 'periodOutstandingStd',
      width: 140,
      formatter: ({ cellValue }) => (cellValue ? cellValue + '%' : '-')
    },
    {
      title: '新建人',
      field: 'opName'
    },
    {
      title: '新建时间',
      field: 'createTime',
      width: 150,
      formatter: ({ cellValue }) => datetimeToSec(cellValue)
    },
    {
      title: '更新人',
      field: 'upOpName'
    },
    {
      title: '更新时间',
      field: 'upTime',
      width: 150,
      formatter: ({ cellValue }) => datetimeToSec(cellValue)
    },
    {
      title: '操作',
      field: 'control',
      slots: { default: 'operation' }
    }
  ]
}

/**
 * @description: 市场KPI列表选项参数
 */
export const marketKpiOptions = {
  border: true,
  showHeaderOverflow: true,
  showOverflow: 'tooltip',
  columnConfig: {
    resizable: true
  },
  data: [],
  height: 500,
  columns: [
    {
      title: '月份',
      field: 'tdate',
      width: 80,
      formatter: ({ cellValue }) => datetimeToMonth(cellValue)
    },
    {
      title: '归属',
      width: 80,
      field: 'ascriptionName'
    },
    {
      title: '中间件游戏',
      field: 'mgameName',
      minWidth: 150
    },
    {
      title: '平台',
      width: 80,
      field: 'platform',
      formatter: ({ cellValue }) => (cellValue >= 0 ? platformData.filter((p) => p.id === cellValue).pop().name : '未知')
    },
    {
      title: '合格目标',
      children: [
        {
          title: '月新增（个）',
          field: 'createRoleNumPass',
          width: 100
        },
        {
          title: '月流水（元）',
          field: 'monthSumMoneyPass',
          width: 100
        },
        {
          title: '月消耗（元）',
          field: 'monthSumAmountPass',
          width: 100
        },
        {
          title: '月活跃衰减（%）',
          field: 'monthMauDeclinePass',
          width: 100
        }
      ]
    },
    {
      title: '优秀目标',
      children: [
        {
          title: '月新增（个）',
          field: 'createRoleNumExcellent',
          width: 100
        },
        {
          title: '月流水（元）',
          field: 'monthSumMoneyExcellent',
          width: 100
        },
        {
          title: '月消耗（元）',
          field: 'monthSumAmountExcellent',
          width: 100
        },
        {
          title: '月活跃衰减（%）',
          field: 'monthMauDeclineExcellent',
          width: 100
        }
      ]
    },
    {
      title: '卓越目标',
      children: [
        {
          title: '月新增（个）',
          field: 'createRoleNumOutstdanding',
          width: 100
        },
        {
          title: '月流水（元）',
          field: 'monthSumMoneyOutstdanding',
          width: 100
        },
        {
          title: '月消耗（元）',
          field: 'monthSumAmountOutstdanding',
          width: 100
        },
        {
          title: '月活跃衰减（%）',
          field: 'monthMauDeclineOutstdanding',
          width: 100
        }
      ]
    },
    {
      title: '新建人',
      field: 'opName',
      width: 120
    },
    {
      title: '新建时间',
      field: 'createTime',
      width: 150,
      formatter: ({ cellValue }) => datetimeToSec(cellValue)
    },
    {
      title: '更新人',
      field: 'upOpName',
      width: 120
    },
    {
      title: '更新时间',
      field: 'upTime',
      width: 150,
      formatter: ({ cellValue }) => datetimeToSec(cellValue)
    },
    {
      title: '操作',
      field: 'control',
      width: 90,
      fixed: 'right',
      slots: { default: 'operation' }
    }
  ]
}
